@if (openSupportChat$ | async; as openSupportChat) {
  <div class="support-chat-window-mobile">
    <ng-template #indicatorTemplate><span nz-icon nzType="loading"></span></ng-template>
    <div class="title-bar">
      <div class="column">
        <nz-spin
          [nzIndicator]="indicatorTemplate"
          [nzSpinning]="loadingOpenSupportChat$ | async"
          class="chat-item-avatar-loading-indicator">
          <app-cr-avatar
            [userName]="openSupportChat.supportChat.supportedUser.name"
            [theme]="'THEME-2'"></app-cr-avatar>
        </nz-spin>
        <span class="user-name" [class.font-size-small]="openSupportChat.supportChat.supportedUser.name.length > 25">
          {{ openSupportChat.supportChat.supportedUser.name }}
        </span>
        <span
          class="presence-dot"
          [class.online]="openSupportChat.supportChat.supportedUserOnline"
          [class.offline]="!openSupportChat.supportChat.supportedUserOnline">
        </span>
      </div>
      <div class="column">
        @if (searchType === ROLES_KEYS.Foreigner) {
          <div class="redirect-button">
            <button
              nz-button
              nzType="text"
              class="title-bar-button"
              *appRequiredSupportingCompany="{
                requiredAccessLevel: SupportingCompanyAccessLevel.canEditProcesses,
                companyId: openSupportChat.supportChat.supportedUser.companyId,
              }"
              (click)="closeWindow($event, openSupportChat.supportChat.id)"
              [routerLink]="['/management/foreigner-details', openSupportChat.supportChat.supportedUserId]"
              [queryParams]="{ tabIndex: 1 }">
              <span class="material-symbols-outlined"> note_stack </span>
            </button>
          </div>
        }
        <div class="close-button">
          <button
            nz-button
            nzType="text"
            class="title-bar-button"
            (click)="closeWindow($event, openSupportChat.supportChat.id)">
            <mat-icon fontSet="material-icons-outlined">close</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="messages-section" #messagesContainer>
      @if ((loadingOpenSupportChat$ | async) === false && !openSupportChat?.messages?.length) {
        <div class="no-messages-info">
          {{ 'CHAT.EMPTY_SUPPORT_CHAT' | translate }}
        </div>
      }
      @for (message of openSupportChat.messages; track message; let messageIndex = $index) {
        <div class="message-wrapper" [class.to-the-right]="message.authorId === myselfId">
          @if (message.authorId !== myselfId) {
            <div
              class="message-author"
              [class.author-deleted]="message.author.deletedAt"
              nz-tooltip
              [nzTooltipTitle]="message.author.name">
              <app-cr-avatar [userName]="message.author.name" [theme]="'THEME-2'"></app-cr-avatar>
            </div>
          }
          <div class="content-wrapper">
            <div
              class="message-content"
              [class.author-message]="message.authorId === myselfId"
              [class.in-edit]="editingMessage?.id === message.id"
              [class.interlocutor-message]="message.authorId !== myselfId"
              [class.is-employee]="message?.author?.role?.key && employeesRoles.includes(message.author.role.key)">
              <div [innerHTML]="message.content | linebreaks"></div>
              @if (message.attachments?.length) {
                <div class="message-attachments-wrapper">
                  @for (attachment of message.attachments; track attachment; let messageAttachmentIndex = $index) {
                    <div (click)="downloadMessageAttachment(message, attachment)" class="message-attachment-item">
                      <span class="attachment-file-icon" nz-icon nzType="paper-clip" nzTheme="outline"></span>
                      <span class="attachment-file-name">{{ attachment.attachment.fileOriginalName }}</span>
                    </div>
                  }
                </div>
              }
            </div>
            <div class="message-meta">
              @if (isEmployee && message.authorId === myselfId) {
                @if (editingMessage?.id !== message.id) {
                  <button (click)="startEditingMessage(message)" nz-button nzType="text" nzSize="small" nzShape="round">
                    {{ 'COMMON.ACTION.EDIT' | translate }}
                  </button>
                }
                @if (editingMessage?.id === message.id) {
                  <button (click)="stopEditingMessage()" nz-button nzType="text" nzSize="small" nzShape="round">
                    {{ 'COMMON.ACTION.CANCEL' | translate }}
                  </button>
                }
                @if (editingMessage?.id !== message.id) {
                  <button (click)="removeMessage(message)" nz-button nzType="text" nzSize="small" nzShape="round">
                    {{ 'COMMON.ACTION.REMOVE' | translate }}
                  </button>
                }
              }
              <span class="creation-date">{{ message.createdAt | date: 'dd.MM.yyyy HH:mm' }}</span>
            </div>
          </div>
          @if (message.authorId === myselfId) {
            <div class="message-author" nz-tooltip [nzTooltipTitle]="message.author.name">
              <app-cr-avatar [userName]="message.author.name" [theme]="'THEME-1'"></app-cr-avatar>
            </div>
          }
        </div>
      }
    </div>
    <div class="input-section">
      <textarea
        nz-input
        (keydown.enter)="sendMessage(openSupportChat.supportChat, $event)"
        (keydown.escape)="editingMessage && stopEditingMessage()"
        [(ngModel)]="messageContent"
        [disabled]="loadingOpenSupportChat$ | async"
        placeholder="{{ 'CHAT.TYPE_YOUR_MESSAGE_HERE' | translate }}"
        [nzAutosize]="{ minRows: 4, maxRows: 8 }"
        #messageInput>
      </textarea>
      <div class="input-buttons">
        <button
          (click)="sendMessage(openSupportChat.supportChat, null)"
          [disabled]="uploadingAttachments || (messageContent.length === 0 && messageAttachments.length === 0)"
          class="send-message-button"
          nz-button
          nzType="text"
          nzSize="default"
          nzShape="circle"
          [attr.aria-busy]="uploadingAttachments">
          @if (uploadingAttachments) {
            <mat-spinner [diameter]="22" [attr.aria-hidden]="true"></mat-spinner>
          } @else {
            <span nz-icon nzType="send" nzTheme="outline"></span>
          }
        </button>
        <button
          (click)="fileUploadInput.click()"
          class="add-attachment-button"
          nz-button
          nzType="text"
          nzSize="default"
          nzShape="circle">
          <nz-badge
            [nzCount]="(messageAttachments?.length || 0) + (existingMessageAttachments?.length || 0)"
            nzSize="small">
            <span nz-icon nzType="paper-clip" nzTheme="outline"></span>
          </nz-badge>
        </button>
      </div>
    </div>
    @if ((attachmentsToAdd$ | async) || existingMessageAttachments?.length) {
      <div class="attachments-section-wrapper">
        <div class="attachments-list-label">
          {{ 'COMMON.LABEL.ATTACHMENTS' | translate }}
        </div>
        <div class="attachments-list">
          @for (item of attachmentsToAdd$ | async; track item; let attachmentIndex = $index) {
            <div class="attachment-asset">
              @if (item.uploaded && item.userAsset?.id) {
                <span class="blued-text">{{ item.fileOriginalName }}</span>
                <mat-icon (click)="removeAsset(item.userAsset)" class="negative">close</mat-icon>
              }
              @if (item.loading) {
                <div class="loading-wrapper" role="status" aria-live="polite">
                  <span class="in-progress-text">
                    {{ item.fileOriginalName }}
                  </span>
                  <span class="sr-only">
                    {{ 'COMMON.LAYOUT.LOADING' | translate }}
                  </span>
                  <mat-spinner [diameter]="25" [attr.aria-hidden]="true"></mat-spinner>
                </div>
              }
              @if (item.error) {
                <span class="error-text">{{ item.fileOriginalName }}</span>
                <mat-icon fontSet="material-icons-outlined" class="error-icon">error</mat-icon>
              }
            </div>
          }
          @if (editingMessage && existingMessageAttachments?.length) {
            @for (
              messageAttachment of existingMessageAttachments;
              track messageAttachment;
              let messageAttachmentIndex = $index
            ) {
              <div class="attachment-asset">
                <span class="blued-text">{{ messageAttachment.attachment.fileOriginalName }}</span>
                <mat-icon (click)="removeExistingMessageAttachment(messageAttachment)" class="negative">close</mat-icon>
              </div>
            }
          }
        </div>
      </div>
    }
    <input
      (change)="uploadFiles($event)"
      #fileUploadInput
      type="file"
      class="file-input-field"
      multiple="true"
      id="attachments-input" />
  </div>
}
